module.exports = __webpack_public_path__ + "img/Pellets-Preiszusammensetzung.c7b9f5b.webp";